namespace Solovis.Reports.Parts.Tables.Exports {


    export class FilterColumnExportDialog {

        private options;
        private _tableControl: Solovis.Reports.Parts.Tables.DataTableControl;
        private _exportMetadata;
        private _saveCallback: (newExportColumnIds) => any;
        private _initialSelectedColumnIds: string[];

        private _columnIdToExportColumnMap: any;

        private _dialog: Solovis.UI.Dialog;

        private _columnFilterDiv;
        private _columnFilterControlHost;

        private _listBuilderDiv;

        private _columnListBuilder: Solovis.UI.VerticalOrderedListBuilder;
        private _columnFilterControl: Solovis.UI.StringFilterListControl;

        constructor(options) {
            this.options = options;
            this._tableControl = options.tableControl;
            this._exportMetadata = options.fullExportMetadata;
            this._saveCallback = options.saveCallback;
            this._initialSelectedColumnIds = options.initialSelectedColumnIds;

            this._columnIdToExportColumnMap = {};
            for (let exportCol of this._exportMetadata.exportColumns) {
                this._columnIdToExportColumnMap[exportCol.id] = exportCol;
            }
        }

        private _getColumnsForAddList() {
            let cols = [];

            let isSelectedColIdMap: any = {};
            let selectedColIds;
            if (this._columnListBuilder) {
                selectedColIds = this._columnListBuilder.getValues();
            }
            else {
                selectedColIds = this._initialSelectedColumnIds;
            }

            $(selectedColIds).each(function (i, id: any) {
                isSelectedColIdMap[id] = true;
            });

            $(this._exportMetadata.exportColumns).each(function (i, col: any) {
                // We only show columns we haven't already added.
                if (!isSelectedColIdMap[col.id]) {
                    cols.push(col);
                }
            });

            return cols;
        }

        private _updateColumnFilterSelectionControl() {
            let self = this;

            let addSelectedItem = function (item?) {
                let exportColumn;
                if (item) {
                    exportColumn = item;
                }
                else {
                    exportColumn = self._columnFilterControl.getSelectedItem();
                }

                if (exportColumn) {                    
                    self._columnListBuilder.addValue(exportColumn.id);
                }
            };

            this._columnFilterControl = new Solovis.UI.StringFilterListControl({
                controlHost: this._columnFilterControlHost,
                listItems: this._getColumnsForAddList(),
                useDefaultSort: false,
                itemDivGenerator: function (itemHolder, filterOptions) {
                    let itemDiv = $("<div class='clear-fix'>").text(itemHolder.item.id);
                    let comboLabelDiv = $("<div>").text(itemHolder.item.comboLabel).css("float", "right").appendTo(itemDiv);

                    itemDiv.click(function () {
                        addSelectedItem(itemHolder.item);
                    });

                    return itemDiv;
                },               

                listFilter: function (itemList, filterOptions) {
                    var resultList = [];

                    var queryTextLower = filterOptions.queryText.toLowerCase();

                    $(itemList).each(function (index, item: any) {
                        let isPrefixMatch = false;
                        let matchFound = false;

                        if (!_.isUndefined(item.comboLabel)) {
                            let labelLower = item.label.toLowerCase();
                            let match = labelLower.indexOf(queryTextLower);
                            if (match !== -1) {
                                isPrefixMatch = match === 0;
                                matchFound = true;
                            }
                        }

                        if (!matchFound) {
                            // Also check the id.
                            let idLower = item.id.toLowerCase();
                            let match = idLower.indexOf(queryTextLower);
                            if (match !== -1) {
                                isPrefixMatch = match === 0;
                                matchFound = true;
                            }
                        }

                        if (matchFound) {
                            resultList.push({
                                isPrefix: isPrefixMatch,
                                item: item
                            });
                        }
                    });

                    return resultList;
                }
            });
            this._columnFilterControl.setAsCurrentControl();
        }

        private _updateAvailableHeight() {
            if (this._dialog) {
                let height = this._dialog.getAvailableContentHeight();
                this._columnFilterControl.setAvailableHeight(height);
                this._listBuilderDiv.outerHeight(height);                
            }
        }

        public show() {
            let self = this;
            let metadata = this._exportMetadata;

            let dialogDiv = $("<div style='height: 100%; display: -ms-flexbox; display: -webkit-box; display: -moz-box; display: -ms-box; display: box;'>");              

            let listBuilderContainerDiv = $("<div style='ms-flex: 1; -webkit-box-flex: 1; -moz-box-flex: 1; -ms-box-flex: 1; box-flex: 1;'>").appendTo(dialogDiv);
            this._listBuilderDiv = $("<div style='padding: 10px; overflow: auto;'>").appendTo(listBuilderContainerDiv); 

            this._columnFilterDiv = $("<div style='width: 300px; ms-flex: 0; -webkit-box-flex: 0; -moz-box-flex: 0; -ms-box-flex: 0; box-flex: 0;'>").appendTo(dialogDiv);            
            this._columnFilterControlHost = new Solovis.UI.ControlHost({ container: this._columnFilterDiv });

            this._updateColumnFilterSelectionControl();

            
            this._columnListBuilder = new Solovis.UI.VerticalOrderedListBuilder({
                controlHost: this._listBuilderDiv,
                
                showEditLinks: false,
                showAddButton: false,

                values: this._initialSelectedColumnIds,

                editorCreator: function (editorDiv, initialValue) {
                    let editorInfo = {
                        columnId: initialValue,

                        getValue: function () {
                            return editorInfo.columnId;
                        }
                    };

                    $("<span>").text(editorInfo.columnId).appendTo(editorDiv);

                    let exportCol = self._columnIdToExportColumnMap[editorInfo.columnId];
                    let colLabel = exportCol ? exportCol.comboLabel : "MISSING";

                    $("<span>").text(" (" + colLabel + ")").appendTo(editorDiv);
                    
                    return editorInfo;
                },

                newValueGenerator: function () {
                    return null;
                },

                itemAddedOrRemoved: function () {
                    if (self._columnFilterControl) {
                        let availableCols = self._getColumnsForAddList();
                        self._columnFilterControl.setListItems(availableCols);
                    }
                }
            });
            this._columnListBuilder.setAsCurrentControl();                     

            function getSelectedColumnIds() {
                let colIds = self._columnListBuilder.getValues();
                return colIds;
            }

            let desiredWidth = Math.min($(window).width() * 0.9, 800);
            let desiredHeight = Math.min($(window).height() * 0.9, 600);

            this._dialog = new Solovis.UI.Dialog({
                container: dialogDiv,

                title: "Filter Export Columns",
                width: desiredWidth,
                minWidth: 500,
                height: desiredHeight,
                modal: true,
                center: true,
                autoOpen: true,
                actions: ["Close"],
                destroyOnClose: true,
                noPaddingOnContent: true,                

                buttons: [
                    {
                        label: "Sync To Visible Columns (Primary Export Only)",
                        click: () => {
                            this.syncToVisibleColumns(true);
                        }
                    },
                    {
                        label: "Sync To Visible Columns",
                        click: () => {
                            this.syncToVisibleColumns();
                        }
                    },
                    {
                        label: "OK",
                        click: function () {
                            let selectedColIds = getSelectedColumnIds();
                            self._saveCallback(selectedColIds);
                            self._dialog.close();
                        }
                    },
                    {
                        label: "Cancel",
                        click: function () {
                            self._dialog.close();
                        }
                    }
                ],

                activate: function () {
                    self._updateAvailableHeight();
                },

                resize: function () {
                    self._updateAvailableHeight();
                }
            });
        }


        public syncToVisibleColumns(primaryOnly?: boolean) {
            let newExportColIds = [];

            let visibleColIds = this._tableControl.columnSet.getVisibleColumnIds();
            for (let visibleColId of visibleColIds) {
                for (let exportColumn of this._exportMetadata.exportColumns) {
                    if (exportColumn.sourceColumnId === visibleColId) {
                        newExportColIds.push(exportColumn.id);         

                        if (primaryOnly) {
                            // We already have first generated column for this actual column.
                            break;
                        }
                    }
                }
            }

            this._columnListBuilder.setValues(newExportColIds);
        }

    }

}
